// This storage is used to save signer payments
import { StateCreator } from 'zustand';
import { SignerPayment } from '../../data/rsTypes';
import { storeResetFns } from '.';

type State = {
	signerPayments: SignerPayment[];
};

type Actions = {
	setSignerPayments: (signerPayments: SignerPayment[]) => void;
	updateSignerPayment: (payment: SignerPayment) => void;
};

export type SignerPaymentsStore = State & Actions;

const initialState: State = {
	signerPayments: undefined,
};

export const createSignerPaymentsSlice: StateCreator<SignerPaymentsStore> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setSignerPayments(signerPayments) {
			set(() => ({ signerPayments }));
		},
		updateSignerPayment(payment) {
			set(state => {
				const existingPayments = state.signerPayments || [];
				const paymentIndex = existingPayments.findIndex(p => p.id === payment.id);

				if (paymentIndex >= 0) {
					const updatedPayments = [...existingPayments];
					updatedPayments[paymentIndex] = payment;
					return { signerPayments: updatedPayments };
				} else {
					return { signerPayments: [...existingPayments, payment] };
				}
			});
		},
	};
};
